import type { JSX } from 'react'
import { Database } from 'lucide-react'

interface DataSourceBadgeProps {
  symbols: string[]
}

export function DataSourceBadge({
  symbols,
}: DataSourceBadgeProps): JSX.Element | null {
  if (symbols.length === 0) return null

  return (
    <div
      data-testid="data-source-badge"
      className="flex items-center gap-1 rounded bg-muted/50 px-2 py-0.5 text-xs text-muted-foreground"
    >
      <Database className="h-3 w-3 shrink-0" />
      <span>{symbols.join(', ')}</span>
    </div>
  )
}
